import { render } from "./AccountLedgerOld.vue?vue&type=template&id=6450a1f1&scoped=true"
import script from "./AccountLedgerOld.vue?vue&type=script&lang=js"
export * from "./AccountLedgerOld.vue?vue&type=script&lang=js"

import "./AccountLedgerOld.vue?vue&type=style&index=0&id=6450a1f1&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6450a1f1"]])

export default __exports__